import React, { useEffect, useState } from 'react';
import StyledTable from "../../../../../commons/styles/table";

const TableSelect = (props) => {
  const [data, setData] = useState(props.data || []);

  useEffect(() => {
    if (props.data !== data) {
      setData(props.data);
    }
  }, [props.data]);

  // const setTranslation = (keyword) => {
  //   const { translationCache } = props;
  //   return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  // };

  return (
    <div style={{ height: '70%', marginTop: '10px' }}>
      <StyledTable size="small"
        columns={props.columns}
        dataSource={data}
        onRow={(record) => ({
          onClick: () => {
            props.handleDropdownChange(record);
          }
        })}
      />
    </div>
  );
};

export default TableSelect;
